import React, { useEffect } from "react";
import { areasItems } from "../../json/areas";
import { Link } from 'react-router-dom';
import './areas.css';


const Areas = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container areas-container'>
        <div className='row'>
            <div className='col_12'>
                <div className='areas_title'>
                    <h1>Áreas</h1>
                </div>
            </div>
        </div>
        <div className="row">
        
          {areasItems.map((item, index ) => (

<Link key={ index } to={ item.enlace ? item.enlace : "DetalleRubro/" + item.enlace } className='col-md-4 col-sm-6 col-12'>
<div class="card card-administrativo">
                    <div class="card-body">
                        <article>
                        <img src={item.imagen2} class="card-img-top"/>
                            <img src={item.imagen} class="card-img-top"/>
                        </article>

                    </div>
                </div>

                </Link>

          ))}
       
        </div>
    </div>
  );
};

export default Areas;